import { render, staticRenderFns } from "./HistoryLogTable.vue?vue&type=template&id=536e14b8&scoped=true"
import script from "./HistoryLogTable.vue?vue&type=script&lang=js"
export * from "./HistoryLogTable.vue?vue&type=script&lang=js"
import style0 from "./HistoryLogTable.vue?vue&type=style&index=0&id=536e14b8&prod&lang=scss"
import style1 from "./HistoryLogTable.vue?vue&type=style&index=1&id=536e14b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e14b8",
  null
  
)

export default component.exports